import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Server01 = function Server01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6 6h.01M6 18h.01m-.81-8h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 8.4802 22 7.92 22 6.8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 2 19.9201 2 18.8 2H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 3.5198 2 4.08 2 5.2v1.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 10 4.08 10 5.2 10m0 12h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.4802 22 19.9201 22 18.8v-1.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 14 19.9201 14 18.8 14H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 15.5198 2 16.0799 2 17.2v1.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 22 4.08 22 5.2 22"
    })
  }));
};
export default Server01;